import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import DelayedRedirect from '../../../../utils/DelayedRedirect';
import { Transition } from '../../../../utils/ModalHelpers';
import { SelectTheme, } from '../../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { TimePicker } from 'antd';
import { DisplayMessage } from '../../../../services/helpers';
import Rodal from "rodal";
import "rodal/lib/rodal.css";
import moment from "moment";
import DeleteIcon from "@material-ui/icons/Delete";
import { BookingWaitSlotsWithOutletIdAndDayIdUrl } from "../../../../constants/apiUrls.js";
import appFetch from '../../../../api/appFetch.js';

const format = 'HH:mm';

export default class OutletWaitSlotsEditing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: null,
      open: true,
      outletDescription: "",
      newWaitSlotHour: null,
      newWaitSlotNumberOfSlots: null,
      newIsForNonWaitingCustomers: false,
      showAddWaitSlot: false,
      waitSlots: [],
      refreshGrid: false,
      showDelete: false,
      requestInProgress: true,
      abandonChanges: false,
    }

    this.DaysNames = [this.props.resources["Sunday"], this.props.resources["Monday"], this.props.resources["Tuesday"],
    this.props.resources["Wednesday"], this.props.resources["Thursday"], this.props.resources["Friday"], this.props.resources["Saturday"]];
  }

  componentDidMount() {
    this.setState({
      outletDescription: this.props.accessibleMoboOutlets?.find(x => x.id == this.props.outletId)?.description ?? "",
      day: this.DaysNames[this.props.dayId],
      waitSlots: this.props.waitSlots ?? [] 
    });
  }

  handleClose = () => {
    this.setState({ open: false, redirect: "/bookingwaitslots" });
  };

  handleClosePageAfterChanges = () => {
    const { requestInProgress } = this.state;
    if (requestInProgress) this.setState({ abandonChanges: false, open: false, redirect: "/bookingwaitslots" });
    else this.setState({ abandonChanges: true });
  }

  

  handleChangeCheckBox = (slotHour, isChecked) => {
    if (slotHour !== undefined && slotHour != 0) {
      var updatedWaitSlot = this.state.waitSlots.find(item => item.slotHour == slotHour);
      updatedWaitSlot.isForNonWaitingCustomers = isChecked;

      this.setState({ waitSlots: this.state.waitSlots, requestInProgress: false, refreshGrid: true});
    }
    else {
      this.setState({ newIsForNonWaitingCustomers: isChecked, refreshGrid: true });
    }
  };

 validateIntegerFromNumberOfSlotsInput = (e, includeDot) => {
    if (e.target.value === "0") e.target.value = "";
    if (includeDot) {
      return (e) =>
        (["e", "E", "+", "-", "*", "."].includes(e.key) ||!isNaN(e.key)) &&
        e.preventDefault();
    } else {
      return (e) =>
        (["e", "E", "+", "-", "*"].includes(e.key) || !isNaN(e.key)) &&
        e.preventDefault();
    }
  }

  handleChangeNumberOfSlots = (slotId, numberOfSlots) => {
    const { resources } = this.props;
    if (numberOfSlots == "" || numberOfSlots == undefined) {
      DisplayMessage(resources["InvalidNumberOfSlots"], "error");
      this.setState({ requestInProgress: true, refreshGrid: true });
    } else {
      var updatedWaitSlot = this.state.waitSlots.find(item => item.slotId == slotId);
      updatedWaitSlot.numberOfSlots = parseInt(numberOfSlots);
      this.setState({ waitSlots: this.state.waitSlots, requestInProgress: false, refreshGrid: true });
    }
  }

  saveWaitSlot = () => {
    const { newWaitSlotHour, newWaitSlotNumberOfSlots, newIsForNonWaitingCustomers } = this.state;
    const { outletId, dayId, resources } = this.props;

    if (newWaitSlotHour === undefined || newWaitSlotHour === null) {
      DisplayMessage(resources["InvalidWaitSlotHour"], "error", 0);
      return;
    }

    if (newWaitSlotNumberOfSlots === "" || newWaitSlotNumberOfSlots === undefined) {
      DisplayMessage(resources["InvalidNumberOfSlots"], "error");
      return;
    }

    var existingWaitSlot = this.state.waitSlots.find(item => item.slotHour == newWaitSlotHour);
    if (existingWaitSlot != undefined) {
      DisplayMessage(resources["WaitSlotExistsAlready"], "error", 0);
    }
    else {
      const payload = { moboOutletId: outletId, slotDay: dayId, slotHour: newWaitSlotHour, numberOfSlots: parseInt(newWaitSlotNumberOfSlots), isForNonWaitingCustomers: newIsForNonWaitingCustomers };
      this.setState({
        waitSlots: [...this.state.waitSlots, { slotId: payload.id, slotHour: payload.slotHour, numberOfSlots: payload.numberOfSlots, isForNonWaitingCustomers: payload.isForNonWaitingCustomers }],
        refreshGrid: true, requestInProgress: false, showAddWaitSlot: false, newWaitSlotHour: 0, newWaitSlotNumberOfSlots: null, newIsForNonWaitingCustomers: false
      });
    }
  }


  closeAddWaitSlot = () => {
    this.setState({ showAddWaitSlot: false, newWaitSlotHour: null, newWaitSlotNumberOfSlots: false });
  }

  handleSubmit = () => {
    this.updateBookingWaitSlots();
  }

  handleRodalClosePage = () => this.setState({ abandonChanges: false })

  updateBookingWaitSlots = () => {
    const { outletId, dayId, resources } = this.props;

    appFetch({
      url: BookingWaitSlotsWithOutletIdAndDayIdUrl(outletId, dayId),
      method: 'PUT',
      body: JSON.stringify(this.state.waitSlots),
      onSuccess: () => {
        DisplayMessage(resources["WaitSlotsUpdatedSuccessfully"], "success");
        this.handleClose();
      },
      onError: (data, response) => {
        if (response.statusText.length > 0) {
          DisplayMessage(response.statusText, "error");
          return response.json();
        }

        for (var i = 0; i < response.errors.length; i++) {
          DisplayMessage(response.errors[i], "error");
        }
      }
    })
  }

  deleteWaitSlot = (slotHour) => {
    this.setState({ waitSlots: this.state.waitSlots.filter(item => item.slotHour != slotHour), refreshGrid: true, requestInProgress: false });
  }

  renderAddWaitSlot = () => {
    const { resources } = this.props;
    const { showAddWaitSlot, newIsForNonWaitingCustomers } = this.state;
    if (showAddWaitSlot)
      return (
        <Form>
          {this.state.waitSlots.length === 0 && (
            <Form.Group className="d-flex mt-3">
              <div className="col-3"></div>
              <div className="col-2 mx-1 px-0">{resources["Hour"]}</div>
              <div className="col-2 mx-1 px-0">{resources["NumberOfSlots"]}</div>
            </Form.Group>
          )}
          <Form.Group className="d-flex" style={{ marginBottom: "0rem" }} >
            <ThemeProvider theme={SelectTheme}>
              <div className="col-3"></div>

              <TimePicker minuteStep={5}
                placeholder={resources["SelectTime"]} format={format} className={"col-2 mx-1"}
                variant="outlined" defaultValue={this.state.newWaitSlotHour !== null ? moment(this.state.newWaitSlotHour, format) : null}
                onChange={(time, timeString) => this.setState({ newWaitSlotHour: timeString })} />

              <TextField id="numberOfSlots-new"
                value={this.state.numberOfSlots}
                type="number"
                variant="outlined"
                name="newNrOfSlots"
                className="col-2 mx-1"
                onChange={(e) => this.setState({ newWaitSlotNumberOfSlots: e.target.value })}
                onKeyDown={(e) => this.validateIntegerFromNumberOfSlotsInput(e, true)}
                inputProps={{ pattern: "[0-9]*", min: 0, inputMode: "numeric", className: "fontSizeOverride", defaultValue: 0 }} />

              <div>
                <IconButton size="small"><CheckIcon onClick={() => this.saveWaitSlot()} /></IconButton>
                <IconButton size="small"><CloseIcon onClick={() => this.closeAddWaitSlot()} /></IconButton>
              </div>

            </ThemeProvider>
          </Form.Group>
          <Form.Group style={{ display: "flex" }} >
            <div className="col-md-3 "> </div>
            <FormControlLabel className="col-md-6"
              control={<Checkbox id="isForNonWaitingCustomers" checked={newIsForNonWaitingCustomers} onChange={(e) => this.handleChangeCheckBox(0, e.target.checked)} name="isForNonWaitingCustomers" color="primary" />}
              label={resources["IsForNonWaitingCustomers"]} />
            <div className="col-md-4"> </div>
          </Form.Group>
        </Form>)
    else return;
  }

  toggleAddWaitSlot = () => {
    this.setState({ showAddWaitSlot: true, newWaitSlotHour: null, newWaitSlotNumberOfSlots: 0, newIsForNonWaitingCustomers: false });
  }

  renderWaitSlotsWithHeaders = () => {
    const { resources } = this.props;

    if (this.state.waitSlots.length > 0) {
      return (
        <Form>
          <Form.Group className="d-flex mt-3">
            <div className="col-3"></div>
            <div className="col-2 mx-1 px-0">{resources["Hour"]}</div>
            <div className="col-2 mx-1 px-0">{resources["NumberOfSlots"]}</div>
          </Form.Group>
          {this.renderWaitSlots()}
        </Form>
      )
    }
    return "";
  } 

  renderWaitSlots = () => {
    const { resources  } = this.props;

    var waitSlots = this.state.waitSlots.map((waitSlot, index) =>
      <Form>
        <Form.Group className="d-flex" style={{ marginBottom: "0rem" }} >
          <ThemeProvider theme={SelectTheme}>
            <div className="col-3"></div>

            <TimePicker format={format} value={moment(waitSlot.slotHour, format)} disabled className="col-2 mx-1" variant="outlined" />

            <TextField className="col-2 mx-1"
              id={`numberOfSlots-${waitSlot.slotId}`}
              inputProps={{ pattern: "[0-9]*", min: 0, inputMode: "numeric", className: "fontSizeOverride" }}
              defaultValue={waitSlot.numberOfSlots}
              name="nrOfSlots"
              type="number"
              variant="outlined"
              onChange={(e) => this.handleChangeNumberOfSlots(waitSlot.slotId, e.target.value)}
              onKeyDown={(e) => this.validateIntegerFromNumberOfSlotsInput(e, true)}
              key={`numberOfSlots-${waitSlot.slotId}`}
            />

            <IconButton size="small" onClick={() => this.deleteWaitSlot(waitSlot.slotHour)}><DeleteIcon /></IconButton>

          </ThemeProvider>
        </Form.Group>
        <Form.Group style={{ display: "flex" }} >
          <div className="col-md-3 "> </div>
          <FormControlLabel className="col-md-6"
            control={<Checkbox id={`wait-slots-is-for-non-waiting-customers-${waitSlot.slotId}`} checked={waitSlot.isForNonWaitingCustomers} onChange={(e) => this.handleChangeCheckBox(waitSlot.slotHour, e.target.checked)} name={`${waitSlot.slotId}`} color="primary" />}
            label={resources["IsForNonWaitingCustomers"]} />
          <div className="col-md-4"> </div>
        </Form.Group>
      </Form>
    )
    return waitSlots;
  }

  renderForm() {
    const { resources } = this.props;
    return (
      <Paper elevation={3} className="p-4 mt-3 mb-3">
        <Form>
          <Form.Group className="d-flex mt-3">
            <div className="col-3"></div>
            <div className="w-100" style={{ textAlign: "left" }}>
              <h6>{resources["Outlet"]} : {this.state.outletDescription}</h6>
              <h6>{resources["Day"]} : {this.state.day}</h6>
            </div>
          </Form.Group>

          {this.renderWaitSlotsWithHeaders()}
          {this.renderAddWaitSlot()}
          {this.state.showAddWaitSlot ? "" :
            <div className="d-flex my-2">
              <div className="col-9 px-0 text-right">
                <Button id="add-language" variant="contained" color="primary" onClick={(e) => { this.toggleAddWaitSlot(e) }}>
                  <i className="fas fa-plus mr-2" title={resources["AddTimeSlot"]} />
                  {resources["AddTimeSlot"]}
                </Button>
              </div>
            </div>
          }
        </Form>
      </Paper>
    );
  }


  renderMain() {
    const { loading } = true;

    if (loading) return (<div className="centered-loader"><CircularProgress /></div>);

    return <div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')} style={{ textAlign: "center" }}>
      {this.renderForm()}
    </div>;
  }


  render() {
    const { redirect, open, refreshGrid, requestInProgress } = this.state;
    const { resources, outletId } = this.props;

    return (
      <div>
        {redirect && <DelayedRedirect to={{ pathname: redirect, state: { outletId, refreshGrid } }} delay={250} />}
        <Dialog fullScreen open={open} onClose={this.handleClosePageAfterChanges} TransitionComponent={Transition}>
          <AppBar className="position-sticky">
            <Toolbar>
              <IconButton id="close-add-waitslots" edge="start" color="inherit" onClick={this.handleClosePageAfterChanges} aria-label="close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" style={{ flex: 1 }}>
                {resources["EditCapacity"]}
              </Typography>
              <Button id="bookingwaitslots-save" color="inherit" disabled={requestInProgress} onClick={this.handleSubmit}>{resources["Save"]}</Button>
            </Toolbar>
          </AppBar>
          <div className="container">
            {this.renderMain()}
          </div>

          <Rodal visible={this.state.abandonChanges} onClose={this.handleRodalClosePage} className="rodal" customStyles={{
            display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'
          }}>
            <div className="modal-body" style={{ marginTop: "20px", display: "flex", alignItems: "center" }}>{resources["AreYouSureYouWantToAbandonTheChanges"]}</div>
            <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
              <button className="btn btn-secondary" id="btnCancelDelete" style={{ backgroundColor: "white", color: "#53B3EA", borderColor: "#53B3EA" }}
                onClick={this.handleRodalClosePage} disabled={this.state.requestInProgress}>{resources["Cancel"]}</button>
              <button className="btn btn-primary" id="btnDelete" style={{ backgroundColor: "#53B3EA", color: "white", borderColor: "#53B3EA" }}
                onClick={this.handleClose} disabled={this.state.requestInProgress}>{resources["Yes"]}</button>

            </div>
            <span className="rodal-close"></span>
          </Rodal>


        </Dialog>
      </div >
    );
  }
}